var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFooterSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 177.733,
    height: 56.218,
    viewBox: "0 0 177.733 56.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_8",
    "data-name": "Rect\\xE1ngulo 8",
    width: 177.733,
    height: 56.218,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M12.243,23.022c.047-.271.051-.361.216-1.388.64-4-4.015-6.577-4.015-6.577a7.944,7.944,0,0,0,5.317-7C14.053,3.347,8.71-3.089.024,1.675a.053.053,0,0,0-.011.078.054.054,0,0,0,.035.021.07.07,0,0,0,.044-.01A6.978,6.978,0,0,1,10.469,8.3a6.921,6.921,0,0,1-4.82,6.2c-.045.014-.043.067,0,.086,1.1.5,3.932,2.586,3.085,7.052-.056.3-.13.746-.163.936-1.486,8.491,8.1,11.008,8.1,11.008a10.554,10.554,0,0,1-4.426-10.56",
    transform: "translate(0 0)",
    fill: "#987744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M24.563,17.669a8.494,8.494,0,0,0-6.679,7.788c-.38,7.091,6.272,7.327,6.181,14.57a8.95,8.95,0,0,1-8.207,8.609.1.1,0,0,0-.02.2,10.322,10.322,0,0,0,12.1-9.4c.682-7.007-6.225-9.708-5.966-14.647.205-3.922,2.691-7.1,8.508-6.9a.048.048,0,0,0,.01-.095,17.986,17.986,0,0,0-5.927-.131",
    transform: "translate(-1.397 -1.548)",
    fill: "#987744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M79.465,29.429V23.857a3.128,3.128,0,0,1-2.973,2.786,3.129,3.129,0,0,1,2.973,2.786",
    transform: "translate(-6.781 -2.114)",
    fill: "#987744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M67.02,35.555H81.477a.571.571,0,0,0,.571-.571V31.333c-.289,1.3-1.88,2.92-3.532,3.722a3.026,3.026,0,0,1-1.323.29h-5.4A2.337,2.337,0,0,0,73.2,33.2V20.071a2.325,2.325,0,0,0-1.418-2.138h5.1a3.2,3.2,0,0,1,2.01.684,6.468,6.468,0,0,1,2.154,3.322V18.287a.572.572,0,0,0-.571-.571H67.02s2.7.563,2.673,2.974V32.582c0,1.55-2.673,2.973-2.673,2.973",
    transform: "translate(-5.941 -1.57)",
    fill: "#987744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M141.841,29.429V23.857a3.128,3.128,0,0,1-2.973,2.786,3.129,3.129,0,0,1,2.973,2.786",
    transform: "translate(-12.31 -2.114)",
    fill: "#987744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M140.909,35.047a3.007,3.007,0,0,1-1.324.293h-5.414a2.332,2.332,0,0,0,1.41-2.141V20.071a2.334,2.334,0,0,0-1.418-2.144h5.1a3.185,3.185,0,0,1,1.989.673,6.462,6.462,0,0,1,2.175,3.338V18.288a.573.573,0,0,0-.571-.572H129.4s2.7.563,2.673,2.974V32.582c0,1.55-2.673,2.974-2.673,2.974h14.457a.572.572,0,0,0,.571-.572V31.333c-.288,1.3-1.869,2.911-3.515,3.715",
    transform: "translate(-11.47 -1.57)",
    fill: "#987744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M64.974,41.807A.092.092,0,0,0,65,41.626c-2.092-.64-3.061-2.608-3.648-3.848-1.5-3.161-.585-5.532-1.921-7.642a4.275,4.275,0,0,0-2.51-2,.09.09,0,0,1,0-.175c3-.676,4.273-2.533,4.273-4.972,0-3.393-2.515-5.278-6.542-5.278h-8.5s2.7.57,2.674,2.98V32.581c0,1.549-2.674,2.973-2.674,2.973h3.829A2.355,2.355,0,0,0,52.339,33.2V20.07a2.361,2.361,0,0,0-1.358-2.136l2.529,0a3.5,3.5,0,0,1,2.356.862,5.681,5.681,0,0,1,1.719,4.195,5.913,5.913,0,0,1-3.268,5,.09.09,0,0,0,0,.159c2.8,1.609,1.559,6.406,3.9,10.2,2.114,3.43,4.971,3.392,6.759,3.47",
    transform: "translate(-4.091 -1.57)",
    fill: "#987744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    "data-name": "Trazado 21",
    d: "M160.642,28.14a.087.087,0,0,1,0-.17c3.016-.668,4.3-2.53,4.3-4.981,0-3.018-2.082-5.278-6.7-5.278l-8.361.005s2.7.564,2.673,2.974V32.582c0,1.549-2.673,2.974-2.673,2.974h3.828a2.356,2.356,0,0,0,2.356-2.356V20.071a2.327,2.327,0,0,0-1.418-2.14h2.55a3.816,3.816,0,0,1,2.476.865,5.692,5.692,0,0,1,1.747,4.191c0,3.048-2.633,4.586-3.368,4.989-.082.045-.079.118,0,.169,3.316,2.08,1.231,8.022,6.288,8.022a4.416,4.416,0,0,0,2.877-.915c-3.708.305-2.439-6.368-6.572-7.112",
    transform: "translate(-13.286 -1.57)",
    fill: "#987744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    "data-name": "Trazado 22",
    d: "M118.323,17.675c1.186.624,1.8,1.726,1.922,3.587a4.017,4.017,0,0,1-.239,1.542L116.79,33.719c-.229.663-.463,1.383-1.11,1.383-.57,0-.719-.385-1.05-1.52l-3.6-12.337a5.3,5.3,0,0,0-5.113-3.922h-2.483s3.017.7,3.76,3.219L111.3,33.6c.682,2.05,2.138,2.145,3.494,2.145,1.633,0,1.909-1.118,2.22-1.974l3.235-11a14.592,14.592,0,0,1,.6-1.488,7.716,7.716,0,0,1,3.5-3.609Z",
    transform: "translate(-9.169 -1.535)",
    fill: "#987744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M192.822,41.612a7.8,7.8,0,0,1-4.113-4.969l-5.156-17.034c-.683-2.05-2.138-2.145-3.5-2.145-1.632,0-1.908,1.118-2.219,1.975l-3.235,11a14.368,14.368,0,0,1-.6,1.487,7.712,7.712,0,0,1-3.5,3.609h6.03c-1.187-.623-1.8-1.726-1.923-3.587a4.036,4.036,0,0,1,.239-1.542l3.216-10.914c.293-.828.5-1.46,1.142-1.46.227,0,.619.039.856.855l4.95,17.063A8.413,8.413,0,0,0,192.8,41.7a.044.044,0,0,0,.019-.083",
    transform: "translate(-15.114 -1.548)",
    fill: "#987744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    d: "M89.783,20.726c0-1.459,1.448-2.781,4.37-2.781a5.812,5.812,0,0,1,.608.032,1.528,1.528,0,0,1,1.126.671,4.084,4.084,0,0,1,.34,2.442,1.762,1.762,0,1,0,3.523,0c0-3.223-3.993-3.367-5.542-3.372-4.566-.015-5.4,2.757-5.374,5.27C88.9,28.8,98.978,29.322,98.978,33.008a1.775,1.775,0,0,1-.128.622A2.839,2.839,0,0,1,96.9,35.321a8.334,8.334,0,0,1-4.195.023,3.064,3.064,0,0,1-1.24-.643,15.219,15.219,0,0,1-3.118-4.366l.026,5.222c.692-1.122,2.348-.262,4.069.027a12.864,12.864,0,0,0,2.314.231A9.078,9.078,0,0,0,98.4,35l.005,0h0a4.055,4.055,0,0,0,2.349-3.874c0-6.066-10.968-6.066-10.968-10.395",
    transform: "translate(-7.831 -1.57)",
    fill: "#987744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M192.832,35.732h.419a.672.672,0,0,0,.1,0l.338.513h.228l-.383-.55a.5.5,0,0,0,.36-.518c0-.34-.228-.536-.639-.536h-.611v1.6h.191Zm0-.921h.419c.283,0,.452.127.452.367s-.169.386-.452.386h-.419Z",
    transform: "translate(-17.076 -3.07)",
    fill: "#987744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M193.122,36.952a1.549,1.549,0,0,0,1.55-1.547,1.543,1.543,0,1,0-1.55,1.547m.009-2.882a1.339,1.339,0,1,1-1.349,1.343,1.333,1.333,0,0,1,1.349-1.343",
    transform: "translate(-16.983 -3.002)",
    fill: "#987744"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooterSvg);
export default __webpack_public_path__ + "static/media/logoFooterSVG.9bb01ccf60f58bfa49b972e710fc0432.svg";
export { ForwardRef as ReactComponent };